import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib';

import { vitrinsQueries } from 'entities/vitrins/model/vitrins.query';
import { setVitrinsOffers } from 'entities/vitrins/model/vitrins.slice';

export const fetchVitrinsThunk = createAsyncThunk('fetchVitrinsThunk', async (_, { dispatch }) => {
  try {
    const response = await dispatch(vitrinsQueries.endpoints.getVitrins.initiate({ productName: 'kredity' })).unwrap();

    if (response) {
      dispatch(setVitrinsOffers(response));
    }

    return response;
  } catch (error) {
    sendSentryClientErrorOnce('fetchVitrinsThunk', error);
    throw error;
  }
});
